var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "lightbox" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "touch",
                rawName: "v-touch:swipe.left",
                value: _vm.Next,
                expression: "Next",
                arg: "swipe",
                modifiers: { left: true }
              },
              {
                name: "touch",
                rawName: "v-touch:swipe.right",
                value: _vm.Previous,
                expression: "Previous",
                arg: "swipe",
                modifiers: { right: true }
              }
            ],
            staticClass: "lightbox__content"
          },
          [
            _c("div", {
              staticClass: "lightbox__content__image",
              style: {
                "background-image": "url(" + _vm.src + ")",
                "max-height": _vm.height + "px",
                "max-width": _vm.width + "px"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lightbox__nav lightbox__nav--close",
            on: { click: _vm.Hide }
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("svg", [
                _c("use", {
                  attrs: {
                    "xlink:href": "/images/icons/symbol-defs.svg#icon-close"
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lightbox__nav lightbox__nav--prev",
            class: { disabled: _vm.navPrevDisabled },
            on: { click: _vm.Previous }
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("svg", [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/images/icons/symbol-defs.svg#icon-arrow-next"
                  }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lightbox__nav lightbox__nav--next",
            class: { disabled: _vm.navNextDisabled },
            on: { click: _vm.Next }
          },
          [
            _c("span", { staticClass: "icon" }, [
              _c("svg", [
                _c("use", {
                  attrs: {
                    "xlink:href":
                      "/images/icons/symbol-defs.svg#icon-arrow-next"
                  }
                })
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f199026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f199026","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/Lightbox/Lightbox.vue
// module id = 530
// module chunks = 3